import { useSelector } from "react-redux";
import Layout from "../../sections/Layout";
import { HomeContainer } from "../../styleComponents/HomeStyle";
import NormalUser from "./NormalUser";
import CheckApps from "./CheckApps";
import { Card, Spinner } from "@chakra-ui/react";
import ProRectorDashboard from "../ProRector/ProRectorDashboard";

const Home = () => {
    const { user, activeRole } = useSelector(s => s);

    // Determine effective role: activeRole if set, otherwise user.role
    const effectiveRole = activeRole || user?.role;

    const isSubmitter = effectiveRole === 1 || effectiveRole === 5;

    let content;
    if (effectiveRole === 3) {
        content = <ProRectorDashboard />;
    } else if (effectiveRole > 1 && effectiveRole !== 5) {
        content = <CheckApps />;
    } else if (isSubmitter) {
        content = <NormalUser />;
    } else {
        content = (
            <div style={{ minHeight: 300 }}>
                <Card style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 20 }}>
                    <Spinner size='lg'
                        thickness='4px'
                        speed='0.65s'
                        emptyColor='gray.200'
                        color='rgb(34, 195, 94)'
                    />
                </Card>
            </div>
        );
    }

    return (<>
        <Layout>
            <HomeContainer>
                {content}
            </HomeContainer>
        </Layout>
    </>)
}
export default Home;